// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEarthOutlinedSvg from "@fishx/icons-svg/es/asn/PEarthOutlined";
import FishxIcon from '../components/FishxIcon';

var PEarthOutlined = function PEarthOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEarthOutlinedSvg
  }));
};

PEarthOutlined.displayName = 'PEarthOutlined';
export default React.forwardRef(PEarthOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEarthOutlined.js
// module id = 3347
// module chunks = 0